const env = import.meta.env as Record<string, string | undefined>

export const API_URL = env.VITE_API_URL ?? 'http://localhost:4005'
export const APP_URL = env.VITE_APP_URL ?? 'http://localhost:3005'
export const SITE_URL = env.VITE_SITE_URL ?? 'http://localhost:4008'
export const MARKETING_URL = 'https://scrambl.com'
export const STATUS_URL = 'https://status.scrambl.com'
export const SITE_NAME = 'Scrambl Help Center'
